const Header = () => {
    return(
        <header> 
            <h1>Recipe Generator</h1>
            <h2>Pick an ingredient to find a recipe!</h2>
        </header>
    )
}

export default Header;